import ChartContent from "./ChartContent";

export default function PlaceholderChartContent() {
  // Rendering ChartContent without statisticsData and diagramData arguments results in placeholder image
  return <ChartContent />;
}
